import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08a7ad2c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=08a7ad2c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a7ad2c')) {
      api.createRecord('08a7ad2c', component.options)
    } else {
      api.reload('08a7ad2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08a7ad2c", function () {
      api.rerender('08a7ad2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientForm/index.vue"
export default component.exports